import React from 'react';

const ConnectionStatus = ({ gameState, connectionError, onRetry }) => {
  const baseStyle = {
    backgroundColor: '#000', 
    minHeight: '100vh', 
    color: '#fff',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center'
  };

  if (gameState === 'connecting') {
    return (
      <div style={baseStyle}>
        <h2>Connecting to server...</h2>
      </div>
    );
  }

  if (gameState === 'reconnecting') {
    return (
      <div style={baseStyle}>
        <h2>Connection Lost</h2>
        <p style={{ color: '#aaa', fontSize: '18px' }}>{connectionError}</p>
        <div style={{ marginTop: '20px' }}>
          <div style={{ 
            width: '50px', 
            height: '50px', 
            border: '4px solid #333',
            borderTop: '4px solid #e14141',
            borderRadius: '50%',
            animation: 'spin 1s linear infinite'
          }}></div>
        </div>
        <style>{`
          @keyframes spin {
            0% { transform: rotate(0deg); }
            100% { transform: rotate(360deg); }
          }
        `}</style>
      </div>
    );
  }

  if (gameState === 'error') {
    return (
      <div style={baseStyle}>
        <h2>Connection Error</h2>
        <p style={{ color: '#aaa' }}>{connectionError}</p>
        
        <button 
          onClick={onRetry}
          style={{
            padding: '10px 20px',
            fontSize: '16px',
            backgroundColor: '#28a745',
            color: 'white',
            border: 'none',
            borderRadius: '5px',
            cursor: 'pointer',
            marginTop: '20px'
          }}
        >
          Retry
        </button>
      </div>
    );
  }

  return null;
};

export default ConnectionStatus;